'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(ImageFit2) {
  ImageFit2["CLAMP"] = "clamp";
  ImageFit2["CLIP"] = "clip";
  ImageFit2["CROP"] = "crop";
  ImageFit2["FACEAREA"] = "facearea";
  ImageFit2["FILL"] = "fill";
  ImageFit2["FILLMAX"] = "fillmax";
  ImageFit2["MAX"] = "max";
  ImageFit2["MIN"] = "min";
  ImageFit2["SCALE"] = "scale";
})(exports.ImageFit || (exports.ImageFit = {}));
(function(ImageAuto2) {
  ImageAuto2["FORMAT"] = "format";
  ImageAuto2["COMPRESS"] = "compress";
  ImageAuto2["FORMAT_AND_COMPRESS"] = "format,compress";
})(exports.ImageAuto || (exports.ImageAuto = {}));
(function(ImageFormat2) {
  ImageFormat2["PNG"] = "png";
  ImageFormat2["JPG"] = "jpg";
  ImageFormat2["WEBP"] = "webp";
  ImageFormat2["PJPG"] = "pjpg";
  ImageFormat2["JSON"] = "json";
  ImageFormat2["AVIF"] = "avif";
  ImageFormat2["SVG"] = "svg";
})(exports.ImageFormat || (exports.ImageFormat = {}));
(function(ImageCrop2) {
  ImageCrop2["TOP"] = "top";
  ImageCrop2["BOTTOM"] = "bottom";
  ImageCrop2["LEFT"] = "left";
  ImageCrop2["RIGHT"] = "right";
  ImageCrop2["FACES"] = "faces";
  ImageCrop2["FOCAL_POINT"] = "focalpoint";
  ImageCrop2["EDGES"] = "edges";
  ImageCrop2["ENTROPY"] = "entropy";
})(exports.ImageCrop || (exports.ImageCrop = {}));
(function(ImageType2) {
  ImageType2["GAME_THUMBNAIL"] = "game-thumbnail";
  ImageType2["GAME_BACKGROUND"] = "game-background";
  ImageType2["GAME_TOKEN"] = "game-token";
  ImageType2["GAME_TOKEN_HISTORY"] = "game-token-history";
  ImageType2["GAME_LOGO_SMALL"] = "game-logo-small";
  ImageType2["GAME_LOGO_LARGE"] = "game-logo-large";
  ImageType2["GAME_DETAIL_BACKGROUND_PORTRAIT"] = "game-detail-background-portrait";
  ImageType2["GAME_DETAIL_BACKGROUND_LANDSCAPE"] = "game-detail-background-landscape";
  ImageType2["GAME_DETAIL_LOGO"] = "game-detail-logo";
  ImageType2["CATEGORY_BACKGROUND"] = "category-background";
  ImageType2["CATEGORY_THUMBNAIL"] = "category-thumbnail";
  ImageType2["OFFER_IMAGES"] = "offer-images";
  ImageType2["OFFER_BACKGROUND"] = "offer-background";
  ImageType2["REWARD_IMAGES"] = "reward-images";
  ImageType2["REWARD_ICONS"] = "reward-icons";
  ImageType2["PAGE_IMAGES"] = "page-images";
  ImageType2["PAGE_BACKGROUND"] = "page-background";
  ImageType2["PROMO_LOBBY"] = "promo-lobby";
  ImageType2["PROMO_MOBILE_BACKGROUND"] = "promo-mobile-background";
  ImageType2["PROMO_IMAGES"] = "promo-images";
  ImageType2["TEASER_IMAGE"] = "teaser-image";
  ImageType2["OMS_IMAGE"] = "oms-image";
  ImageType2["CALENDAR_BACKGROUNDS"] = "calendar-backgrounds";
  ImageType2["BONUSES_IMAGES"] = "bonuses-images";
  ImageType2["LOTTERY_BACKGROUND"] = "lottery-background";
  ImageType2["LOTTERY_LOGOS"] = "lottery-logos";
  ImageType2["CASHIER_LOGO"] = "cashier-logo";
})(exports.ImageType || (exports.ImageType = {}));
const imageTypeToPath = {
  [exports.ImageType.GAME_THUMBNAIL]: "games/thumbs",
  [exports.ImageType.GAME_BACKGROUND]: "games/bgs",
  [exports.ImageType.GAME_TOKEN]: "games/token/main",
  [exports.ImageType.GAME_TOKEN_HISTORY]: "games/token/history",
  [exports.ImageType.GAME_LOGO_SMALL]: "games/logos/sm",
  [exports.ImageType.GAME_LOGO_LARGE]: "games/logos/lg",
  [exports.ImageType.GAME_DETAIL_BACKGROUND_PORTRAIT]: "games/detail/portrait/bgs",
  [exports.ImageType.GAME_DETAIL_BACKGROUND_LANDSCAPE]: "games/detail/landscape/bgs",
  [exports.ImageType.GAME_DETAIL_LOGO]: "games/detail/logo",
  [exports.ImageType.CATEGORY_BACKGROUND]: "categories/bgs",
  [exports.ImageType.CATEGORY_THUMBNAIL]: "categories/thumbs",
  [exports.ImageType.OFFER_IMAGES]: "offers/img",
  [exports.ImageType.OFFER_BACKGROUND]: "offers/bgs/lg",
  [exports.ImageType.REWARD_IMAGES]: "rewards/img",
  [exports.ImageType.REWARD_ICONS]: "rewards/icon",
  [exports.ImageType.PAGE_IMAGES]: "pages/img",
  [exports.ImageType.PAGE_BACKGROUND]: "pages/bgs/lg",
  [exports.ImageType.PROMO_LOBBY]: "promos/src",
  [exports.ImageType.PROMO_MOBILE_BACKGROUND]: "promos/mobile",
  [exports.ImageType.PROMO_IMAGES]: "promos/img",
  [exports.ImageType.TEASER_IMAGE]: "teasers",
  [exports.ImageType.OMS_IMAGE]: "oms",
  [exports.ImageType.CALENDAR_BACKGROUNDS]: "calendars/bgs/lg",
  [exports.ImageType.BONUSES_IMAGES]: "bonuses/img",
  [exports.ImageType.LOTTERY_BACKGROUND]: "lottery/bgs/lg",
  [exports.ImageType.LOTTERY_LOGOS]: "lottery/img",
  [exports.ImageType.CASHIER_LOGO]: "cashier/logo"
};
function getImagePath(type, imageName) {
  return `${imageTypeToPath[type]}${imageName ? `/${imageName}` : ""}`;
}
class CdnService {
  setup(imgCdnUrl) {
    this.imgCdnUrl = imgCdnUrl;
  }
  getImageUrl(imagePath, params) {
    let url = `${this.imgCdnUrl}/${imagePath.replace(/^(\/+)/, "")}`;
    if (params && Object.keys(params).length) {
      url += `?${this.mapImgParams(params)}`;
    }
    return url;
  }
  getPageImageUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.PAGE_IMAGES, imagePath), params);
  }
  getOfferImageUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.OFFER_IMAGES, imagePath), params);
  }
  getPromotionImageUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.PROMO_IMAGES, imagePath), params);
  }
  getPageBackgroundUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.PAGE_BACKGROUND, imagePath), params);
  }
  getOfferBackgroundUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.OFFER_BACKGROUND, imagePath), params);
  }
  getPromotionBackgroundUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.PROMO_LOBBY, imagePath), params);
  }
  getLandingMobileBackgroundUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.PROMO_MOBILE_BACKGROUND, imagePath), params);
  }
  getLandingBackgroundUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.PROMO_LOBBY, imagePath), params);
  }
  getPromotionMobileBackgroundUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.PROMO_MOBILE_BACKGROUND, imagePath), params);
  }
  getThumbnailUrl(gameId, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.GAME_THUMBNAIL, `${gameId}.jpg`), params);
  }
  getRewardsImageUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.REWARD_IMAGES, imagePath), params);
  }
  getRewardsIconUrl(iconPath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.REWARD_ICONS, iconPath), params);
  }
  getLotteryLogoUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.LOTTERY_LOGOS, imagePath), params);
  }
  getLotteryBackgroundUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.LOTTERY_BACKGROUND, imagePath), params);
  }
  getOmsImageUrl(imagePath, params) {
    return this.getImageUrl(getImagePath(exports.ImageType.OMS_IMAGE, imagePath), params);
  }
  mapImgParams(params) {
    const mappedParams = {
      w: this.round(params.width),
      h: this.round(params.height),
      q: params.quality,
      dpr: params.retina === true ? 2 : void 0,
      fit: params.fit,
      crop: params.crop,
      auto: params.auto,
      bg: params.bg,
      lossless: params.lossless,
      fm: params.format,
      ["min-w"]: this.round(params.minWidth),
      ["min-h"]: this.round(params.minHeight)
    };
    if (mappedParams.auto === exports.ImageAuto.FORMAT && !mappedParams.fm) {
      mappedParams.fm = exports.ImageFormat.JPG;
    }
    return Object.entries(mappedParams).filter(([, val]) => val !== void 0).map(([key, val]) => encodeURIComponent(key) + "=" + encodeURIComponent(val)).join("&");
  }
  round(num) {
    if (num === "auto") {
      return num;
    }
    return num ? Math.round(num) : num;
  }
}
const cdnService = new CdnService();

exports.CdnService = CdnService;
exports.cdnService = cdnService;
exports.getImagePath = getImagePath;
exports.imageTypeToPath = imageTypeToPath;
